import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const StatsSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const statsData = labels.menuPages?.howItWorks?.overviewSection?.stats || [];

  const colors = [
    "text-blue-600",
    "text-green-600",
    "text-purple-600",
    "text-orange-600",
  ];

  const stats = statsData.map((stat: any, index: number) => ({
    number: stat.number || "",
    label: stat.label || "",
    color: colors[index] || colors[0],
  }));

  return (
    <div className="mt-24">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((stat, index) => (
          <div key={index} className="text-center">
            <div
              className={`text-3xl md:text-4xl font-bold ${stat.color} mb-2`}
            >
              {stat.number}
            </div>
            <div className="text-gray-600 text-sm md:text-base">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsSection;
